import { LOCAL_STORAGE_KEY } from '@common/constants';
import { ApiUrl } from '@common/enums';
import { RetailerSettings } from '@common/models';
import { cleanCompanyCode } from '@common/utils';
import { easyEstimatorApi } from '@ee-api/easyEstimatorService';

export type RetailerSettingsParams = {
    params?: Partial<{ [key in LOCAL_STORAGE_KEY.USER_TOKEN]: string }>;
};

const retailerSettingsService = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchRetailerSettings: builder.query<RetailerSettings, RetailerSettingsParams>({
            query: ({ params }) => ({
                url: ApiUrl.RETAILER_SETTINGS,
                method: 'GET',
                params,
            }),
            transformResponse: (data: RetailerSettings) => ({
                ...data,
                companyCode: cleanCompanyCode(data.companyCode),
            }),
            extraOptions: { maxRetries: 1 },
        }),
    }),
});

export const { useFetchRetailerSettingsQuery } = retailerSettingsService;
